export const DEFAULTS = {
  config: {},
  configViewer: {
    hideMarkdown: true,
  },
};
